import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { InstagramProps } from "./types";
import {
    EntryOptions,
    PropertyDefinition, PropertyMappingType
} from "app/library/layout-builder";
import { ImageChildrenDefinitions } from 'components/cms/definitions';
import { MetaTypeEnum } from 'app/shared';

export class InstagramDefinitions extends CmsReactComponent<InstagramProps> {

    static schemaName = "instagram";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "data",
        description: "Veri Elemanları",
        mapping: {
            type: PropertyMappingType.ArrayData,
            keys: [
                {
                    name: "image",
                    mapping: {
                        type: PropertyMappingType.ParentObject,
                        children: ImageChildrenDefinitions,
                    },
                    text: "Görsel",
                },
                {
                    name: "anchor",
                    text: "URL",
                    mapping: {
                        type: PropertyMappingType.LinkWizard,
                    },
                    default: null,
                }]
        }
    }];

    static options: EntryOptions = {
        meta: {
            use: false,
            allowedTypes: [],
        },
        mappingFields: [
            {
                name: "image",
                text: "Görsel",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "anchor",
                text: "URL",
                types: [MetaTypeEnum.Link]
            },
        ],
    };

}
